// extracted by mini-css-extract-plugin
export default {"suggestionsContainer":"style_suggestionsContainer__nAlFB","explanation":"style_explanation__8veOC","suggestionTitle":"style_suggestionTitle__d93m+"};